import type {
  WhiteboardRecordModels,
  WhiteboardRecordTypeNames,
} from '../shared-types';

export const recordTypesToTypename: Record<
  WhiteboardRecordTypeNames,
  WhiteboardRecordModels['typename']
> = {
  epics: 'Epic',
  features: 'Feature',
  goals: 'Goal',
  ideas: 'Idea',
  ideaThemes: 'IdeaTheme',
  initiatives: 'Initiative',
  keyResults: 'KeyResult',
  pages: 'Page',
  pdlcSteps: 'PdlcStep',
  releases: 'Release',
  releasePhases: 'ReleasePhase',
  requirements: 'Requirement',
  tasks: 'Task',
  projects: 'Project',
};

export function normalizeRecordType(
  recordType: WhiteboardRecordTypeNames | WhiteboardRecordModels['typename']
): WhiteboardRecordModels['typename'] {
  return recordTypesToTypename[recordType] || recordType;
}

// This could go in guards.ts, but as this has more to do with records than
// whiteboards, it's here.
export function isWhiteboardRecordTypeName(
  recordType: string
): recordType is WhiteboardRecordTypeNames {
  return (
    recordType in recordTypesToTypename ||
    Object.values(recordTypesToTypename).includes(recordType)
  );
}

// Copied from javascripts/record_icons
export const RECORD_ICONS = {
  Competitor: 'fa-solid fa-trophy',
  Epic: 'aha-icon aha-icon-epic-solid',
  Feature: 'fa-solid fa-grid-2 fa-fw',
  Goal: 'fa-solid fa-flag',
  Idea: 'fa-solid fa-lightbulb', // NOTE: the class get stored as just Idea in case of integration trigger
  'Ideas::Idea': 'fa-solid fa-lightbulb',
  IdeaTheme: 'fa-solid fa-tags',
  Initiative: 'fa-solid fa-sitemap',
  MasterFeature: 'aha-icon aha-icon-epic-solid',
  MasterRelease: 'fa-solid fa-calendar-lines',
  Page: 'fa-solid fa-file-lines',
  Persona: 'fa-solid fa-address-card',
  Project: 'fa-regular fa-browser',
  Release: 'fa-solid fa-calendar-lines',
  ReleasePhase: 'fa-solid fa-timeline fa-fw',
  Requirement: 'fa-solid fa-list',
  StrategicImperative: 'fa-solid fa-flag',
  Task: 'aha-icon aha-icon-complete',
  'Polls::Poll': 'fa-solid fa-chart-simple',
};

// From app/assets/stylesheets/record_reference_pill.less
export const RECORD_ICON_DEFAULT_BACKGROUND_COLOR =
  'var(--theme-tertiary-text)';
export const RECORD_ICON_BACKGROUND_COLORS = {
  Epic: 'var(--aha-purple-300)',
  Feature: 'var(--aha-blue-500)',
  Goal: 'var(--aha-teal-600)',
  Idea: 'var(--aha-green-700)', // NOTE: the class get stored as just Idea in case of integration trigger
  'Ideas::Idea': 'var(--aha-green-700)',
  IdeaTheme: 'var(--aha-green-500)',
  Initiative: 'var(--aha-pink-600)',
  MasterFeature: 'var(--aha-purple-300)',
  MasterRelease: 'var(--theme-secondary-text)',
  Release: 'var(--theme-secondary-text)',
  Requirement: 'var(--aha-orange-700)',
  StrategicImperative: 'var(--aha-teal-600)',
};
